import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from '@refinedev/core';

const { TextArea } = Input;

interface CommentModalProps {
  open: boolean;
  onClose: () => void;
  sectionId?: number;
  isLoading?: boolean;
  handleAddComment: (comment: string) => void;
}

export const CommentModal: React.FC<CommentModalProps> = ({
  open,
  onClose,
  isLoading,
  handleAddComment,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();
  const handleSubmit = async () => {
    const values = await form.validateFields();
    handleAddComment(values.comment);
    form.resetFields();
  };
  return (
    <Modal
      title={translate('comments.add')}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {translate('buttons.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isLoading}
          onClick={handleSubmit}
        >
          {translate('buttons.submit')}
        </Button>,
      ]}
      centered
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="comment"
          label={translate('comments.content')}
          rules={[
            {
              required: true,
              message: translate('comments.required'),
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
